import React from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Paper,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import SemanticModelCard from './SemanticModelCard';
import ViewToggle from './ViewToggle';

const SemanticModelSection = ({
  activeRecords,
  deletedRecords,
  filter,
  onFilterChange,
  onCreate,
  currentView = 'list',
  onViewChange,
  onView,
  onEdit,
  onDelete,
  onGraphView,
  onSelect,
  selectedModelId,
  isLoading,
  error,
  databaseIndex
}) => {
  const recordsToRender = filter === 'deleted' ? deletedRecords : activeRecords;

  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: 'var(--wb-bg-elevated)',
        p: 3,
        borderRadius: 2,
        mb: 4
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        <Box>
          <Typography variant="h6" color="var(--wb-text-strong)">
            Modelos semánticos
          </Typography>
          <Tabs
            value={filter}
            onChange={(_, value) => onFilterChange(value)}
            textColor="secondary"
            indicatorColor="secondary"
            sx={{ mt: 1 }}
          >
            <Tab
              label={`Activos (${activeRecords.length})`}
              value="active"
              sx={{ color: 'var(--wb-text)' }}
            />
            <Tab
              label={`Eliminados (${deletedRecords.length})`}
              value="deleted"
              sx={{ color: 'var(--wb-text)' }}
            />
          </Tabs>
        </Box>

        <ViewToggle currentView={currentView} onViewChange={onViewChange} onCreate={onCreate} />
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress sx={{ color: 'var(--wb-accent)' }} />
        </Box>
      ) : recordsToRender.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <Typography variant="body1" color="var(--wb-text-strong)">
            {filter === 'deleted'
              ? 'No hay modelos semánticos eliminados.'
              : 'Aún no se han registrado modelos semánticos.'}
          </Typography>
        </Box>
      ) : (
        recordsToRender.map((item) => (
          <SemanticModelCard
            key={item.semantic_model_id || item.id}
            record={item}
            databaseName={
              item?.semantid_database_id
                ? databaseIndex[item.semantid_database_id]?.name ||
                  databaseIndex[item.semantid_database_id]?.semantic_database_id ||
                  ''
                : ''
            }
            onView={onView}
            onEdit={onEdit}
            onDelete={onDelete}
            onGraphView={onGraphView}
            onSelect={onSelect}
            isSelected={selectedModelId === (item.semantic_model_id || item.id)}
            isDeleted={filter === 'deleted' || item?.soft_delete?.deleted}
          />
        ))
      )}
    </Paper>
  );
};

export default SemanticModelSection;
